import { render, staticRenderFns } from "./SidebarTabElement.vue?vue&type=template&id=be87ceb4&"
import script from "./SidebarTabElement.vue?vue&type=script&lang=js&"
export * from "./SidebarTabElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports